import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { RequestService } from '@foundation/network/services';
import { NotificationService } from '@foundation/notification';
import { RouterLink } from '@angular/router';
import { TranslateDirective } from '@foundation/translations/services';
import { UsersRepository } from '@foundation/users/state';
import { tap } from 'rxjs';

@Component({
	selector: 'lib-admin-dashboard',
	standalone: true,
	imports: [CommonModule, RouterLink, TranslateDirective],
	templateUrl: './admin-dashboard.component.html',
	styleUrl: './admin-dashboard.component.css',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminDashboardComponent {
	usersRepository = inject(UsersRepository);
	private _requestService = inject(RequestService);
	private _notificationService = inject(NotificationService);

	isEmailVerificationLoading = signal(false);

	sendEmailVerification() {
		if (this.isEmailVerificationLoading()) return;
		this.isEmailVerificationLoading.set(true);
		this._requestService
			.post$<{ message: string; email: string }>('/api/users/email/send-verification', {})
			.pipe(
				tap((response) => {
					this.isEmailVerificationLoading.set(false);
					if (response.error) {
						this._notificationService.error(response.error.title, response.error.description || 'Failed to send verification email');
						return;
					}
					if (response.result) {
						this._notificationService.success(`A verification email has been sent to ${response.result.email}. Please check your inbox and click the verification link.`, 'Verification email sent!');
					}
				})
			)
			.subscribe();
	}
}
